<script>
export default {
  name: 'InfoPopOver',
  props: {
    onChecked: Function,
    price: Number,
    popUpHeadline: String,
    headline: String,
    popUpText: String,
    checkBoxId: String,
    checked: {
      type: Boolean,
      default: false
    },
    enablePopUp: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPopUp: false,
      checkBoxID: 'checkbox-id-1-' + this.checkBoxId
    };
  },
  computed: {},
  methods: {
    togglePopUp: function() {
      this.showPopUp = !this.showPopUp;
    }
  }
};
</script>

<template>
  <div class="form-details-add-opposite-street">
    <div class="mb-10">
      <strong class="options">
        <label :for="checkBoxID" class="inline">
          <input @change="onChecked" class="mr-10" :id="checkBoxID" type="checkbox" :checked="checked" />
          <span v-html="headline"></span>
        </label>
      </strong>

      <div
        v-if="enablePopUp"
        @mouseover="togglePopUp"
        @mouseout="togglePopUp"
        class="form-details-add-opposite-street-badge"
      >
        <i class="fa fa-info" />
        <div v-if="showPopUp" class="form-details-add-opposite-street-popup">
          <div class="arrow"></div>
          <h3 class="popover-title">{{ popUpHeadline }}</h3>
          <div class="popover-content" v-html="popUpText" />
        </div>
      </div>

      <span class="ml-5" v-bind:value="'+' + price + ' €'" />
    </div>
  </div>
</template>
<style lang="scss">
@import 'InfoPopOver';
</style>
